import styled from 'styled-components';
import * as Switch from '@radix-ui/react-switch';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';

var Root = styled(Switch.Root).withConfig({
  displayName: "Root",
  componentId: "sc-11snnvq-0"
})(["--switch-height:", ";--switch-width:", ";flex-shrink:0;width:var(--switch-width);height:var(--switch-height);background-color:", ";border-radius:var(--switch-height);position:relative;-webkit-tap-highlight-color:rgba(0,0,0,0);transition:all 300ms;&[data-state='checked']{background-color:black;}&[data-disabled]{opacity:0.5;}"], function (p) {
  return pxToRem(p.$radii);
}, function (p) {
  return pxToRem(p.$radii * 2);
}, themeGet('colors.primary.200'));
var Handle = styled(Switch.Thumb).withConfig({
  displayName: "Handle",
  componentId: "sc-11snnvq-1"
})(["--handle-spacing:", ";--handle-radii:calc(", " - var(--handle-spacing) * 2);display:block;width:var(--handle-radii);height:var(--handle-radii);background-color:", ";border-radius:", ";box-shadow:0 ", " ", " rgba(0,0,0,0.15);transition:transform 300ms ease-in-out;transform:translateX(var(--handle-spacing));will-change:transform;&[data-state='checked']{transform:translateX(calc(var(--switch-width) - var(--handle-radii) - var(--handle-spacing)));}"], pxToRem(2), function (p) {
  return pxToRem(p.$radii);
}, themeGet('colors.gray.0'), themeGet('borderRadius.circle'), pxToRem(2), pxToRem(5));

export { Handle, Root };
